import { takeLatest } from 'redux-saga/effects';
import { casesActions } from './slice';
import { getCasesWorker, getCaseDetailWorker } from './business.saga';

export function* casesSaga() {
  yield takeLatest(casesActions.getCases.type, getCasesWorker);
  yield takeLatest(casesActions.getCaseDetail.type, getCaseDetailWorker);
}
